import React from 'react'
import { Form, Input } from 'antd'
import { useTranslation } from 'lib/i18n'

const CompanyWebsite: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Form.Item
      name={['VIDEO_REQUEST', 'businessWebsite']}
      label={t('VideoRequestForm.companyWebsiteLabel', 'Company website')}
      rules={[
        {
          validator: (_, value, callback) => {
            if (
              !value ||
              /[//(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}/g.test(value)
            ) {
              callback()
            } else {
              callback(
                t(
                  'VideoRequestForm.websiteValidator',
                  'Please input a valid URL',
                ),
              )
            }
          },
        },
      ]}
      data-cy="companyWebsiteInputItem"
    >
      <Input size="large" autoComplete="off" data-cy="companyWebsiteInput" />
    </Form.Item>
  )
}

export default CompanyWebsite
